import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  section: {
    paddingBottom: theme.spacing(1.875),
  },

  bestOf: {
    fontWeight: 400,
    whiteSpace: 'nowrap',
    wordWrap: 'break-word',
    fontFamily: '"Noto Sans"',
    fontSize: theme.spacing(1.75),
  },
}));
